import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {momentDatetime} from 'utils/common';

export default class CalendarDate extends React.Component {
  static propTypes = {
    datetime: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
    className: PropTypes.string.isRequired,
  };
  static defaultProps = {
    className: '',
  };

  constructor(props) {
    super(props);
    const datetime = momentDatetime(props.datetime);
    this.dayOfWeek = datetime.format('dddd');
    this.dayOfMonth = datetime.format('DD');
    this.month = datetime.format('MMMM');
  }

  render() {
    const {className} = this.props;
    return (
      <div className={classNames('calendar-date', className)}>
        <div>{this.dayOfWeek}</div>
        <div>{this.dayOfMonth}</div>
        <div>{this.month}</div>
      </div>
    );
  }
}
